<div id="pias-layout-container" [class.pias-layout-container-is-mobile]="isMobile()">
    <mat-toolbar class="pias-layout-toolbar">
        <button matIconButton (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
        <img src="assets/images/PIAS-logo.png" alt="PIAS Logo" class="img img-fluid" width="120" />
        <span class="pias-header-spacer"></span>
        <button matButton="elevated" (click)="logout()">
            <mat-icon>logout</mat-icon>
            Logout
        </button>
    </mat-toolbar>

    <mat-sidenav-container class="pias-layout-sidenav-container" [style.marginTop.px]="isMobile() ? 56 : 0">
        <mat-sidenav class="pias-sidenav" #snav [opened]="true" [mode]="isMobile() ? 'over' : 'side'"
            [fixedInViewport]="isMobile()" fixedTopGap="56">
            <div id="sidenav-header">
                <div class="mt-2 mb-1 px-3 sidenav-title">Welcome, <br><span>{{this.currentUserPersonName}}</span>!</div>
                <!-- <div class="mb-3 px-3 sidenav-caption">Role: <span>{{this.userCategory}}</span></div> -->
            </div>
            <mat-nav-list class="pias-sidenav-list">

                @for(menuItem of menuItems; track menuItem) {
                    <app-menu-item [item]="menuItem"></app-menu-item>
                }
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content>
            <div id="pias-layout-content" class="container-fluid">
                <ng-content select="[pias-layout-content]"></ng-content>
            </div>

            <!-- <div id="pias-footer">
                <span>© 2025 Professional Investment Advisory Services Pte Ltd&nbsp;|&nbsp;PIAS is wholly owned by Singapore Life Ltd.&nbsp;|&nbsp;Co. Reg. No. 200106346Z&nbsp;|&nbsp;FA Licence No. FA000008</span>
            </div> -->
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>